import { useFormik } from 'formik'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import InputEmail from '../../Inputs/InputEmail/InputEmail'
import InputPhone from '../../Inputs/InputPhone/InputPhone'
import InputText from '../../Inputs/InputText/InputText'
import FormLayout from '../FormLayout/FormLayout'

import './FormWithoutLogin.scss'

const FormWithoutLogin = ({ title, loading, handleSubmit, className }) => {
    const intl = useIntl()

    const formik = useFormik({
        initialValues: {
            firstname: '',
            lastname: '',
            emailWithoutLogin: '',
            phone: '',
        },
        validationSchema: Yup.object({
            firstname: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
            lastname: Yup.string().required(intl.formatMessage({ id: 'forms.required' })),
            emailWithoutLogin: Yup.string()
                .email(intl.formatMessage({ id: 'forms.register.emailError' }))
                .required(intl.formatMessage({ id: 'forms.required' })),
            phone: Yup.string()
                .matches(/^[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/, intl.formatMessage({ id: 'forms.register.phoneError' }))
                .required(intl.formatMessage({ id: 'forms.required' })),
        }),
        onSubmit: ({ firstname, lastname, emailWithoutLogin, phone }) => {
            const withoutLoginData = {
                firstname,
                lastname,
                email: emailWithoutLogin,
                phone: String(phone),
            }

            handleSubmit(withoutLoginData)
        },
    })

    return (
        <FormLayout
            title={title}
            color={'transparent'}
            onSubmit={formik.handleSubmit}
            className={`form-without-login d-flex flex-column ${className}`}
        >
            <InputText
                name={'firstname'}
                id={'firstname'}
                error={formik?.errors?.firstname}
                touched={formik?.touched?.firstname}
                {...formik.getFieldProps('firstname')}
                label={intl.formatMessage({ id: 'forms.register.nameLabel' })}
                placeholder={intl.formatMessage({ id: 'forms.register.namePlaceholder' })}
                onBlur={formik?.handleBlur}
            />
            <InputText
                name={'lastname'}
                id={'lastname'}
                error={formik?.errors?.lastname}
                touched={formik?.touched?.lastname}
                {...formik.getFieldProps('lastname')}
                label={intl.formatMessage({ id: 'forms.register.surnameLabel' })}
                placeholder={intl.formatMessage({ id: 'forms.register.surnamePlaceholder' })}
                onBlur={formik?.handleBlur}
            />
            <InputEmail
                name={'emailWithoutLogin'}
                id={'emailWithoutLogin'}
                error={formik?.errors?.emailWithoutLogin}
                touched={formik?.touched?.emailWithoutLogin}
                {...formik.getFieldProps('emailWithoutLogin')}
                label={intl.formatMessage({ id: 'forms.register.emailLabel' })}
                placeholder={intl.formatMessage({ id: 'forms.register.emailPlaceholder' })}
                onBlur={formik?.handleBlur}
            />
            <InputPhone
                name={'phone'}
                id={'phone'}
                error={formik?.errors?.phone}
                touched={formik?.touched?.phone}
                {...formik.getFieldProps('phone')}
                label={intl.formatMessage({ id: 'forms.register.phoneLabel' })}
                placeholder={intl.formatMessage({ id: 'forms.register.phonePlaceholder' })}
                onBlur={formik?.handleBlur}
            />

            <div className="align-self-end mt-auto">
                <ButtonCinestar variant={'primary-v1'} type={'submit'} disabled={loading}>
                    {intl.formatMessage({ id: 'buttons.continue' })}
                </ButtonCinestar>
            </div>
        </FormLayout>
    )
}

export default FormWithoutLogin
